export default "__VITE_ASSET__T3uzNSLo__"